<template>
	<div
		v-if="shouldShowBanner"
		class="relative bg-won-red-light py-3"
	>
		<div class="relative mx-auto flex h-full max-w-7xl items-center justify-between gap-4 pr-12 pl-4 sm:gap-8 sm:px-6 lg:px-6">
			<p
				v-if="phase === 'grace' || phase === 'nuisance'"
				class="flex-1 shrink-0 text-left font-[Inter] text-sm whitespace-nowrap text-won-red sm:text-base"
			>
				<span class="font-semibold">Payment failed.</span> We had trouble processing your payment. You still have premium access for
				{{ daysRemaining }} {{ daysRemaining === 1 ? 'day' : 'days' }} — please update your payment info to keep it uninterrupted.
			</p>

			<p
				v-else
				class="flex-1 shrink-0 text-left font-[Inter] text-sm whitespace-nowrap text-won-red sm:text-base"
			>
				<span class="font-semibold">Your premium access has expired</span> — but you can jump back in anytime.
				Get hired faster with unlimited WonsultingAI support.
			</p>

			<div class="flex shrink-0 items-center gap-3">
				<Button
					class="bg-won-red hover:bg-won-red-dark"
					@click="handleUpdatePayment"
				>
					Update Payment
				</Button>
			</div>
		</div>
		<button
			v-if="canDismiss"
			type="button"
			class="absolute top-1/2 right-2 flex -translate-y-1/2 rounded-md p-2 transition-colors hover:bg-red-200 focus:ring-2 focus:ring-red-400 focus:outline-hidden sm:right-4"
			@click="dismiss"
		>
			<span class="sr-only">Dismiss</span>
			<XMarkIcon class="size-3 text-won-red" />
		</button>
	</div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { XMarkIcon } from '@heroicons/vue/24/outline';
import Button from './library/button.vue';
import { usePaymentRecovery } from '../composables/usePaymentRecovery';

const router = useRouter();

const {
	phase,
	daysRemaining,
	shouldShowBanner,
	canDismiss,
	dismiss,
	fetchStatus,
	initializeFromUser,
} = usePaymentRecovery();

const handleUpdatePayment = () => {
	router.push({ path: '/settings', query: { tab: 'billing', highlight: 'payment' } });
};

onMounted(async () => {
	initializeFromUser();
	if (phase.value !== 'none') {
		await fetchStatus();
	}
});
</script>
